import React, {Component} from 'react';
import ConfigModal from "./modals/ConfigModal";

class ConfigBox extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showConfigModal: false
    };

    render() {
        return (
            <div className="panel box">
                <div className="box-row">
                    <div className="box-cell p-x-3 p-y-1">
                        <div className="pull-xs-left font-weight-semibold font-size-12">КОНФИГУРАЦИЯ</div>
                    </div>
                </div>
                <div className="box-container valign-middle">
                    <div className="box-cell p-y-2 p-r-1 p-l-3">
                        <button className="btn btn-default btn-outline btn-block"
                                onClick={() => this.setState({showConfigModal: true})}>
                            <i className="fa fa-eye"/> Посмотреть
                        </button>
                    </div>
                    <div className="box-cell p-y-2 p-r-3 p-l-1">
                        <button className="btn btn-default btn-outline btn-block">
                            <i className="fa fa-download"/> Скачать
                        </button>
                    </div>
                </div>
                <ConfigModal show={this.state.showConfigModal}
                             onHide={() => this.setState({showConfigModal: false})}/>
            </div>
        );
    }
}

export default ConfigBox;


// WEBPACK FOOTER //
// ./src/pages/Developers/SystemOverview/ConfigBox.js